import { Radio, RadioIndicatorProps } from '@mantine/core'
import React from 'react'

export const RadioIndicator = (props: RadioIndicatorProps) => (
  <Radio.Indicator {...props} />
)
